<template>
  <div>
    <div class="league-hat">
      <!--country-icon class="country-icon" v-if="league._country.code !== undefined" :code="league._country.iso" :name="league._country.name_ru" /-->
      <div class="league-name ellipsis" v-if="this.$i18n.locale === 'ru'">{{ league.name_ru }}</div>
      <div class="league-name ellipsis" v-if="this.$i18n.locale === 'en'">{{ league.name_en }}</div>
      <div class="league-name ellipsis" v-if="this.$i18n.locale === 'az'">{{ league.name_az }}</div>
      <!--div class="league-name ellipsis" v-if="this.$i18n.locale === 'ru' && league.country === undefined" :style="{ marginLeft: '33px' }">{{ league.name_ru }}</div>
      <div class="league-name ellipsis" v-if="this.$i18n.locale === 'en' && league.country === undefined" :style="{ marginLeft: '33px' }">{{ league.name_en }}</div>
      <div class="league-name ellipsis" v-if="this.$i18n.locale === 'az' && league.country === undefined" :style="{ marginLeft: '33px' }">{{ league.name_az }}</div-->
    </div>
    <div class="list">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import CountryIcon from '@/components/icons/CountryIcon'

export default {
  components: {
    CountryIcon
  },
  props: {
    league: Object,
    sport: Number
  }
}
</script>

<style scoped>
.league-hat { display: flex; background: #e6e6fa; }
.country-icon { flex-shrink: 0; margin-left: -2px; height: 32px !important; margin-top: 5px; }
.league-name { flex: 1; padding-right: 10px; margin-left: 5px; line-height: 40px; }
.list { background: rgba(255, 255, 255, .05); position: block; }
</style>



// WEBPACK FOOTER //
// src/components/header/SearchLeague.vue